"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.observable = observable, exports.DriverObservable = void 0;

function observable(a) {
  return new DriverObservable(a);
}

var DriverObservable = /*#__PURE__*/function () {
  function DriverObservable(a) {
    _classCallCheck(this, DriverObservable);

    this.driver = a;
  }

  _createClass(DriverObservable, [{
    key: "postMessage",
    value: function postMessage(a) {
      this.driver.postMessage(a);
      var b = this;
      return {
        on: function on(c) {
          return b.driver.addMessageListener(function (b) {
            b.id === a.id && c(b);
          });
        }
      };
    }
  }]);

  return DriverObservable;
}();

exports.DriverObservable = DriverObservable;